import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChartBarIcon, UserPlusIcon, BookOpenIcon } from '@heroicons/react/24/outline';

function Home() {
  const [email, setEmail] = useState('');

  const handleSubscribe = (e) => {
    e.preventDefault();
    // Handle email subscription
    alert('Gracias por suscribirte. Te contactaremos pronto.');
    setEmail('');
  };

  const features = [
    {
      icon: ChartBarIcon,
      title: 'Evaluaciones Completas',
      description: 'Tests psicológicos validados MBTI, VIA y Eneagrama con análisis detallado',
    },
    {
      icon: BookOpenIcon,
      title: 'Seguimiento de Progreso',
      description: 'Mide tu crecimiento personal a lo largo del tiempo con métricas objetivas',
    },
    {
      icon: UserPlusIcon,
      title: 'Comparación Personal',
      description: 'Compara tus resultados entre diferentes sesiones para ver tu evolución',
    },
  ];

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      {/* Hero Section */}
      <div className="text-center mb-16">
        <h1 className="text-4xl font-bold text-gray-900 mb-6">
          Descubre tu Potencial con Autoconocimiento
        </h1>
        <p className="text-xl text-gray-600 mb-8 max-w-3xl mx-auto">
          Realiza evaluaciones psicológicas profesionales y rastrea tu crecimiento personal 
          con herramientas científicas y metodologías validadas.
        </p>
        <div className="flex justify-center space-x-4">
          <Link
            to="/register"
            className="bg-indigo-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-indigo-700 transition-colors"
          >
            Comenzar Ahora
          </Link>
          <Link
            to="/dashboard"
            className="bg-white text-indigo-600 px-6 py-3 rounded-lg font-medium border border-indigo-600 hover:bg-indigo-50 transition-colors"
          >
            Ver Demo
          </Link>
        </div>
      </div>

      {/* Features Section */}
      <div className="mb-16">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
          ¿Qué Ofrecemos?
        </h2>
        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div
                key={index}
                className="bg-white p-6 rounded-lg card-shadow hover-lift transition-all"
              >
                <div className="flex items-center mb-4">
                  <Icon className="h-8 w-8 text-indigo-600 mr-3" />
                  <h3 className="text-lg font-semibold text-gray-900">
                    {feature.title}
                  </h3>
                </div>
                <p className="text-gray-600">{feature.description}</p>
              </div>
            );
          })}
        </div>
      </div>

      {/* Tests Section */}
      <div className="mb-16">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
          Nuestros Tests Psicológicos
        </h2>
        <div className="grid md:grid-cols-3 gap-8">
          <div className="bg-white p-6 rounded-lg card-shadow">
            <h3 className="text-xl font-semibold text-gray-900 mb-4">16 Personalidades (MBTI)</h3>
            <p className="text-gray-600 mb-4">
              Descubre tu tipo de personalidad basado en las dimensiones de Myers-Briggs. 
              Ideal para entender tus preferencias naturales y cómo interactúas con el mundo.
            </p>
            <div className="flex items-center justify-between">
              <span className="text-sm text-gray-500">12 minutos</span>
              <span className="bg-green-100 text-green-800 px-2 py-1 rounded text-sm">
                Gratis
              </span>
            </div>
          </div>
          
          <div className="bg-white p-6 rounded-lg card-shadow">
            <h3 className="text-xl font-semibold text-gray-900 mb-4">Fortalezas de Carácter (VIA)</h3>
            <p className="text-gray-600 mb-4">
              Identifica tus 24 fortalezas de carácter principales y descubre cómo 
              utilizarlas para alcanzar tu máximo potencial y bienestar.
            </p>
            <div className="flex items-center justify-between">
              <span className="text-sm text-gray-500">90 preguntas</span>
              <span className="bg-green-100 text-green-800 px-2 py-1 rounded text-sm">
                Gratis
              </span>
            </div>
          </div>
          
          <div className="bg-white p-6 rounded-lg card-shadow">
            <h3 className="text-xl font-semibold text-gray-900 mb-4">Eneagrama</h3>
            <p className="text-gray-600 mb-4">
              Explora tus motivaciones profundas, miedos y patrones de comportamiento 
              a través del sistema del Eneagrama.
            </p>
            <div className="flex items-center justify-between">
              <span className="text-sm text-gray-500">45 minutos</span>
              <span className="bg-green-100 text-green-800 px-2 py-1 rounded text-sm">
                Gratis
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="bg-gradient-to-r from-indigo-600 to-purple-600 rounded-lg p-8 text-center text-white">
        <h2 className="text-3xl font-bold mb-4">
          ¿Listo para Comenzar Tu Viaje de Autoconocimiento?
        </h2>
        <p className="text-lg mb-6 opacity-90">
          Únete a miles de personas que han descubierto su verdadero potencial
        </p>
        <Link
          to="/register"
          className="bg-white text-indigo-600 px-8 py-3 rounded-lg font-medium hover:bg-gray-100 transition-colors inline-block"
        >
          Registrarte Gratis
        </Link>
      </div>

      {/* Newsletter Section */}
      <div className="mt-16 bg-white rounded-lg p-8 card-shadow">
        <div className="max-w-2xl mx-auto text-center">
          <h3 className="text-2xl font-bold text-gray-900 mb-4">
            Recibe Consejos de Desarrollo Personal
          </h3>
          <p className="text-gray-600 mb-6">
            Suscríbete a nuestro newsletter semanal con tips, técnicas y reflexiones 
            para tu crecimiento personal.
          </p>
          <form onSubmit={handleSubscribe} className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Tu correo electrónico"
              className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
              required
            />
            <button
              type="submit"
              className="bg-indigo-600 text-white px-6 py-2 rounded-lg font-medium hover:bg-indigo-700 transition-colors"
            >
              Suscribirse
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Home;